/**
 * T-0894 (`docs/concept-mobile-app.md`, LC-6g, its third part): what the launch entry checks with
 * `instanceof` about the desktop's keychain, without the vault. A browser's entry reaches it through
 * the sign-in's failure wording (`signInFailure.ts`) and `ApiService`; the vault itself
 * (`desktopSessionVault.ts`) loads through `desktopSessionLazy.ts`. It imports nothing.
 */

/**
 * I-2572 (MS-2): the keychain did not answer a read of the session, so this page cannot renew it now.
 * Not a session end: nothing says the session is over, and the keychain still holds it. The launch
 * shows "Reconnecting…" for it and tries again.
 */
export class DesktopKeychainUnavailableError extends Error {
  constructor() {
    super('The keychain did not give back the sign-in. It is kept, and is asked for again.');
    this.name = 'DesktopKeychainUnavailableError';
  }
}
